import { Box, Typography } from '@mui/material'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

export default function EstimationTimeDate({
  message,
  from,
  to,
  format = "hh:mm A"
}) {
  const { t } = useTranslation()

  const formatDateInEnglish = (date) => {
    return moment(date).format(format);
  };

  return (
    <Box>
      {
        (!!from && !!to) &&
        <Box>
          {
            from !== to ?
              <Box display="flex" alignItems="center">
                <Typography sx={{ mr: 1 }} style={{ color: 'grey' }} variant='h5'>
                  {t(message)}
                </Typography>
                <span style={{ fontSize: "20px", fontWeight: "bold", color: "grey" }}>{t("from")}</span>
                <Typography color="secondary" sx={{ mx: 1, fontWeight: "bold" }}>
                  {formatDateInEnglish(from)}
                </Typography>
                <span style={{ fontSize: "20px", fontWeight: "bold", color: "grey" }}>{t("to")}</span>
                <Typography color="secondary" sx={{ ml: 1, fontWeight: "bold" }}>
                  {formatDateInEnglish(to)}
                </Typography>
              </Box>
              :
              <Box display="flex" alignItems="center">
                <Typography sx={{ mr: 1 }} style={{ color: 'grey' }} variant='h5'>
                  {t(message)}
                </Typography>
                {/* <span style={{ fontSize: "20px", fontWeight: "bold", color: "grey" }}>{t("at")}</span> */}
                <Typography color="secondary" sx={{ mx: 1, fontWeight: "bold" }}>
                  {formatDateInEnglish(from)}
                </Typography>
              </Box>
          }
        </Box>
      }
    </Box>
  )
}
